import {
  GetAttributionsParams,
  UpdateEmailBuilderSettingsParams,
  createABTestVariantion,
} from './../../email-builder/src/types/index'
import axios from 'axios'
import {
  IContactSearchOptions,
  ISmartList,
  FetchSmartList,
  IPreviewMessage,
  FetchHtmlPreview,
  SwitchVersionOptions,
  FetchTemplateVersions,
  Template,
  IEmailScheduleOptions,
  CreateImporterTaskParams,
  SendVerificationEmailParams,
  VerifyEmailParams,
  FetchTagsParams,
} from '../types'
import { getEmailServiceHeader } from './../utils/helper'

export function getContactSearchService(config: any) {
  return function (params: IContactSearchOptions) {
    const {
      locationId,
      query = '',
      tag = '',
      limit = 20,
      assignedTo,
      page = 1,
    } = params
    return axios.get(`${config.newAppEngineUrl}/search/contact/all`, {
      params: {
        location_id: locationId,
        q: query,
        limit,
        orderBy: 'name',
        assigned_to: assignedTo,
        tag,
        page,
        exists: 'email',
      },
    })
  }
}
export function getFetchSmartLists(config: any) {
  return function (params: ISmartList) {
    return axios.post(`${config.appengineUrl}/smartlist/user_lists`, params)
  }
}

export function getFetchSmartListContacts(config: any) {
  return function (params: FetchSmartList) {
    return axios.post(`${config.contacts}/search/2`, params)
  }
}

export function getFetchTags(config: any) {
  return function (payload: FetchTagsParams) {
    const { locationId, ...params } = payload

    return axios.get(
      `${config.marketPlaceURL}/locations/${locationId}/tags/search`,
      {
        params: { ...params, getCount: true },
        headers: {
          'internal-channel': 'email-builder',
          'location-id': locationId,
        },
      }
    )
  }
}

export function getMessagePreview(config: any) {
  return function (params: IPreviewMessage) {
    return axios.post(`${config.appengineUrl}/message/preview`, params)
  }
}

export function getHTMLPreview(config: any) {
  return function (payload: FetchHtmlPreview) {
    const { locationId, id, version = 0 } = payload

    let requestURL = `${config.marketPlaceURL}/emails/builder/html/${locationId}/${id}/${version}`
    return axios.get(requestURL)
  }
}

export function getSwitchVersion(config: any) {
  return function (params: SwitchVersionOptions) {
    let requestURL = `${config.marketPlaceURL}/emails/builder/switch-versions`
    return axios.post(requestURL, params)
  }
}

export function getVersionHistory(config: any) {
  return function (payload: FetchTemplateVersions) {
    const { id, locationId } = payload

    let requestURL = `${config.marketPlaceURL}/emails/builder/versions/${locationId}/${id}`
    return axios.get(requestURL)
  }
}

export function getCustomValues(config: any) {
  return function (locationId: string) {
    return axios.get(config.marketPlaceURL + '/custom-data/emails', {
      params: {
        locationId,
        types: 'custom-values',
      },
      headers: {
        'internal-channel': 'email-builder',
        'location-id': locationId,
      },
    })
  }
}

export function getCustomFields(config: any) {
  return function (locationId: string) {
    return axios.get(
      `${config.marketPlaceURL}/locations/${locationId}/customFields`,
      {
        headers: {
          'internal-channel': 'email-builder',
          'location-id': locationId,
        },
      }
    )
  }
}

export function fetchTriggerLinks(config: any) {
  return function (locationId: string) {
    return axios.get(`${config.marketPlaceURL}/links/`, {
      params: { locationId },
      headers: {
        'internal-channel': 'email-builder',
        'location-id': locationId,
      },
    })
  }
}

export function getUpdateTemplate(config: any) {
  return function (id: string, params: Template) {
    let requestURL = `${config.marketPlaceURL}/emails/builder/meta/${id}`
    return axios.put(requestURL, params)
  }
}
export function getUpdateCampaign(config: any) {
  return function updateCampaign({
    locationId,
    campaignId,
    params,
  }: {
    locationId: string
    params: IEmailScheduleOptions
    campaignId: string
  }) {
    return axios.patch(
      `${config.marketPlaceURL}/emails/schedule/${locationId}/${campaignId}`,
      params
    )
  }
}

export function getCampaignMeta(config: any) {
  return function (
    locationId: string,
    campaignId: string,
    campaignStats = false
  ) {
    return axios.get(
      `${config.marketPlaceURL}/emails/schedule/meta/${locationId}/${campaignId}`,
      {
        params: { campaignStats },
      }
    )
  }
}
export function getBulkActionV2(config: any) {
  return function (bulkRequestId: string) {
    return axios.get(
      `${config.marketPlaceURL}/bulk-actions/request/${bulkRequestId}/`
    )
  }
}
export function getCreateABtestVariation(config: any) {
  return function createABTestVariation(params: createABTestVariantion) {
    let requestURL = `${config.marketPlaceURL}/emails/schedule/create-ab-variation`
    return axios.post(requestURL, params)
  }
}

export function getAiContent(config: any) {
  return function getAiContentById(
    id: string,
    locationId: string,
    type?: string
  ) {
    let requestURL =
      type === 'image'
        ? `${config.contentAI}/images/${id}?locationId=${locationId}`
        : `${config.contentAI}/posts/${id}?locationId=${locationId}`
    return axios.get(requestURL)
  }
}

export function getCurrencyDetails(config: any) {
  return function getCurrencySymbols() {
    return axios.get(`${config.emailReportingUrl}/payments/currency`)
  }
}

export function getAttributionDetails(config: any) {
  return function getAttributions(params: GetAttributionsParams) {
    return axios.get(`${config.marketPlaceURL}/emails/attribution`, { params })
  }
}

export function getEmailSettings(config: any) {
  return function getEmailBuilderSettings(locationId: string) {
    return axios.get(
      `${config.marketPlaceURL}/emails/builder/settings/${locationId}`
    )
  }
}

export function updateEmailSettings(config: any) {
  return function updateEmailBuilderSettings(
    locationId: string,
    params: UpdateEmailBuilderSettingsParams
  ) {
    return axios.post(
      `${config.marketPlaceURL}/emails/builder/settings/${locationId}`,
      params
    )
  }
}

export function createNewImporterTask(config: any) {
  return function createNewImporter(params: CreateImporterTaskParams) {
    return axios.post(`${config.marketPlaceURL}/emails/webhook/import`, params)
  }
}

export function fetchImporterStatus(config: any) {
  return function getImporterStatus(id: string) {
    return axios.get(`${config.marketPlaceURL}/emails/webhook/import/${id}`)
  }
}

export function getCampaignStats(config: any) {
  return function getStats(locationId: string, params: any) {
    return axios.get(
      `${config.marketPlaceURL}/emails/stats/location/${locationId}`,
      { params }
    )
  }
}

export function sendVerificationEmail(config: any) {
  return function sendVerificationEmail(params: SendVerificationEmailParams) {
    return axios.post(
      `${config.marketPlaceURL}/emails/otp-verification/send`,
      params
    )
  }
}

export function verifyEmailOtp(config: any) {
  return function verifyEmailOtp(params: VerifyEmailParams) {
    return axios.post(
      `${config.marketPlaceURL}/emails/otp-verification/verify`,
      params
    )
  }
}

export function getEmailProvider(config: any) {
  return function getEmailProvider(locationId: string) {
    return axios.post(
      `${config.marketPlaceURL}/email-isv/contracts/location-email-provider`,
      {
        locationId,
      }
    )
  }
}
